<template>
    <div>
        <el-row>
            <el-col :span="12">
                <h1>Proposal</h1>
            </el-col>
            <el-col :span="12" style="display: flex; flex-direction: column; gap: 6rem">
                <div style="display: flex; gap: 1rem; justify-content: end">
                    <btn icon="fas fa-step-backward" :click="goBack">Go Back to Proposals</btn>
                    <btn icon="fas fa-step-backward" :disabled="!tab_form.employer_id" :click="goToEmployerDetail">Go Back to Employer's Proposals</btn>
                    <btn icon="fas fa-copy" :click="cloneProposal">Clone</btn>
                </div>
                <div style="display: flex; gap: 1rem; justify-content: end">
                    <btn cssClass="btn btn-secondary" icon="fas fa-external-link" :click="() => $emit('saveAndPreview')">Save and Preview</btn>
                    <btn icon="fas fa-save" :click="() => $emit('save')">Save</btn>
                </div>
            </el-col>
        </el-row>

        <el-row v-if="proposal.signed_at">
            <el-col :span="12" class="alert alert-danger">
                This document is signed from the customer and can't be changed anymore.
            </el-col>
        </el-row>

        <el-form-item v-if="tab_form.employer_id" label="Employer Name">
            <el-select v-model="tab_form.employer_id" style="width:100%" filterable required="required">
                <el-option
                    v-for="option in employers"
                    :value="option.id"
                    :label="option.name"
                    :key="`employer-${option.id}`">
                    <span style="float: left">{{ option.name }} ({{ option.id }})</span>
                    <span style="float: right">{{ option.state }}</span>
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item v-else label="Employer Name">
            <el-input v-model="tab_form.name"></el-input>
        </el-form-item>
    </div>
</template>

<script>

export default {
    props: {
        proposal: {
            type: Object,
            required: true
        },
        tab_form: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            employers: [],
        };
    },
    methods: {
        cloneProposal() {
            window.location.href = url(`admin/proposal2/${this.proposal.id}/clone`);
        },
        goBack() {
            window.location.href = url(`admin/proposal2/list`);
        },
        goToEmployerDetail() {
            window.location.href = url(`admin/employer/${this.tab_form.employer_id}/proposals`);
        },
    },
    mounted() {
        axios.get(url(`admin/employers/dropdown?inactive=1`))
            .then((response) => {
                this.employers = response.data;
            });
    }
}
</script>

<style>
.proposal h2 {
    margin-top: 50px !important;
}
.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before, h2.is-required:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
}
</style>
